// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getStorage } from "firebase/storage"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCPzvmDkNsdgHZ9Fh0ePZYyXhTq2mL3epo",
  authDomain: "ecommerce-image-upload-b540d.firebaseapp.com",
  projectId: "ecommerce-image-upload-b540d",
  storageBucket: "ecommerce-image-upload-b540d.appspot.com",
  messagingSenderId: "552980547833",
  appId: "1:552980547833:web:8d89c138e6517c361f3a28",
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const storage = getStorage(app)
